import type { ReactNode } from 'react';

/** A section of a page that couldn't load, while the rest of the page still works. */
export function Unavailable({
  children,
  onRetry,
  testid,
}: {
  children: ReactNode;
  onRetry: () => void;
  testid?: string;
}) {
  return (
    <div className="rpc-notice rpc-notice--row panel-unavailable" role="status" data-testid={testid}>
      <span>{children}</span>
      <button className="btn btn-sm" type="button" onClick={onRetry}>
        Try again
      </button>
    </div>
  );
}
